import { useRoute } from 'shared/src/hooks/useRoute';

export type GoodsRouteParams = {
  RecentlyViewedGoods: {
    instanceId?: string;
  };
  GoodsDetail: {
    instanceId?: string;
    goodsId: number;
    extras?: {
      logging_analytics?: string;
      goods_name: string;
      market_name: string;
      cover_image: string;
      market_image: string;
      discount_rate: number;
      original_price: number;
      price: number;
      from?: string;
      coupon_sno?: number;
      /** 메타피드 click → PDP launch 시 전달되는 광고 정보 (JSON string) */
      ad?: string;
    };
  };
  GoodsList: {
    instanceId?: string;
    type: string;
    goodsSno: number;
    landingFrom?: string;
    position?: string;
  };
};

export const useGoodsRoute = <Key extends keyof GoodsRouteParams>() =>
  useRoute<GoodsRouteParams, Key>();
